import { __awaiter, __generator } from "tslib";
import { defineComponent, reactive } from 'vue';
import { useService } from '@kaokei/use-vue-service';
import { useRouter, useRoute } from 'vue-router';
import { DaoService } from '@/services/dao.service';
import { USER_EXAM_PASSED, USER_EXAM_AWARDED, value2label, formatDateToSecond, preloadIDE, getBaseInfoText } from '@/utils';
import ExamNoticeModal from '@/components/contest/ExamNoticeModal.vue';
export default defineComponent({
  name: 'ContestTable',
  components: {
    ExamNoticeModal: ExamNoticeModal
  },
  props: {
    list: {
      type: Array
    },
    pagination: {
      type: Object
    }
  },
  setup: function (props) {
    var _this = this;
    var route = useRoute();
    var columns = [{
      title: '比赛阶段',
      dataIndex: 'contestStageName',
      key: 'contestStageName',
      width: 100,
      slots: {
        customRender: 'contestStageName'
      },
      fixed: 'left'
    }, {
      title: '比赛信息',
      key: 'contestInfo',
      slots: {
        customRender: 'contestInfo'
      },
      width: 200,
      fixed: 'left'
    }, {
      title: '比赛开始时间',
      key: 'startTime',
      slots: {
        customRender: 'startTime'
      },
      width: 160
    }, {
      title: '比赛结束时间',
      key: 'endTime',
      slots: {
        customRender: 'endTime'
      },
      width: 160
    }, {
      title: '组别',
      dataIndex: 'contestScheduledName',
      key: 'contestScheduledName',
      width: 200
    }, {
      title: '得分',
      key: 'totalScore',
      slots: {
        customRender: 'totalScore'
      },
      width: 80
    }, {
      title: '操作',
      key: 'operation',
      fixed: 'right',
      slots: {
        customRender: 'operation'
      }
    }];
    var router = useRouter();
    var daoService = useService(DaoService);
    var checkDetail = function (item) {
      var _a;
      router.push({
        name: (_a = route.meta) === null || _a === void 0 ? void 0 : _a.detailPathName,
        params: {
          id: item.userExamId
        },
        query: route.query
      });
    };
    var examInfo = reactive({
      userExamId: 0,
      visible: false,
      baseInfoText: '',
      answerRule: '',
      contestId: 0,
      commitmentLetterTitle: '',
      userName: ''
    });
    var showExamInfo = function (item) {
      return __awaiter(_this, void 0, void 0, function () {
        var showAction;
        var _a;
        return __generator(this, function (_b) {
          if ((_a = item.userSupportCheck) === null || _a === void 0 ? void 0 : _a.deviceCheckConfig) {
            if (item.examType === 1) {
              daoService.preStartMockExam(item.userExamId).then(function () {
                goCheckDevice(item);
              });
            } else {
              goCheckDevice(item);
            }
            return [2 /*return*/];
          }
          showAction = function () {
            daoService.getExamInfo(item.userExamId).then(function (info) {
              examInfo.baseInfoText = getBaseInfoText(info.questionInfoList);
              examInfo.answerRule = info.answerRule;
              preloadIDE(); // 预加载ide
              examInfo.userExamId = item.userExamId;
              examInfo.visible = true;
              examInfo.contestId = item.contestInfoId;
              examInfo.userName = info.userName || '';
              examInfo.commitmentLetterTitle = info.commitmentLetterTitle || '';
            });
          };
          if (item.examType === 1) {
            daoService.preStartMockExam(item.userExamId).then(function () {
              showAction();
            });
          } else {
            showAction();
          }
          return [2 /*return*/];
        });
      });
    };
    var goToExamAnswer = function (item) {
      router.push({
        name: 'Examination',
        params: {
          id: item.userExamId,
          answerId: item.answerPaperId
        }
      });
    };
    var getBtnText = function (item) {
      if (item.examType === 1) {
        return '去模拟';
      }
      return '去比赛';
    };
    var getRowClassName = function (record) {
      if (record.status === 1) {
        return 'row-ing';
      }
      if (record.status === 0 && record.endTime < Date.now()) {
        return 'row-ended';
      }
      return '';
    };
    var goCheckDevice = function (record) {
      var queryData = {
        id: record.userExamId,
        contestId: record.contestInfoId
      };
      var queryDataBase64 = window.btoa(JSON.stringify(queryData));
      router.push({
        name: route.meta.deviceCheckName || 'DeviceCheck',
        query: {
          qs: queryDataBase64
        }
      });
    };
    return {
      examInfo: examInfo,
      columns: columns,
      USER_EXAM_PASSED: USER_EXAM_PASSED,
      USER_EXAM_AWARDED: USER_EXAM_AWARDED,
      value2label: value2label,
      checkDetail: checkDetail,
      showExamInfo: showExamInfo,
      formatDateToSecond: formatDateToSecond,
      goToExamAnswer: goToExamAnswer,
      getBtnText: getBtnText,
      getRowClassName: getRowClassName,
      goCheckDevice: goCheckDevice
    };
  }
});